// extracted by mini-css-extract-plugin
export default {"root":"SelectionList_root__qppq5","bordered":"SelectionList_bordered__9KsFo"};